import { render, staticRenderFns } from "./certify.vue?vue&type=template&id=18376d90&"
import script from "./certify.vue?vue&type=script&lang=js&"
export * from "./certify.vue?vue&type=script&lang=js&"
import style0 from "./certify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports